import { render } from "./SnacksHeader.vue?vue&type=template&id=713e068c&scoped=true"
import script from "./SnacksHeader.vue?vue&type=script&lang=js"
export * from "./SnacksHeader.vue?vue&type=script&lang=js"

import "./SnacksHeader.vue?vue&type=style&index=0&id=713e068c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713e068c"]])

export default __exports__